import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router'
import { LoadingSpinner } from '../components/LoadingSpinner'
import { ProtectedLayout } from './ProtectedLayout'
import { ProtectedAdminRoute } from '../components/ProtectedAdminRoute'
import Layout from '../components/Layout'

const Login = lazy(() => import('../pages/Login'))
const Dashboard = lazy(() => import('../pages/Dashboard'))
const Pacientes = lazy(() => import('../pages/Pacientes'))
const Atenciones = lazy(() => import('../pages/Atenciones'))
const Calendario = lazy(() => import('../pages/Calendario'))
const Tratamientos = lazy(() => import('../pages/Tratamientos'))
const Gastos = lazy(() => import('../pages/Gastos'))
const Reportes = lazy(() => import('../pages/Reportes'))
const Configuracion = lazy(() => import('../pages/Configuracion'))
const Usuarios = lazy(() => import('../pages/Usuarios'))

function LazyPage({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<LoadingSpinner />}>{children}</Suspense>
}

interface AppRoutesProps {
  isAuthenticated: boolean
  homePage: string
}

export function AppRoutes({ isAuthenticated, homePage }: AppRoutesProps) {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            <Navigate to={homePage} replace />
          ) : (
            <LazyPage>
              <Login />
            </LazyPage>
          )
        }
      />

      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<Navigate to={homePage} replace />} />
        <Route path="/dashboard" element={<LazyPage><Dashboard /></LazyPage>} />
        <Route path="/pacientes" element={<LazyPage><Pacientes /></LazyPage>} />
        <Route path="/atenciones" element={<LazyPage><Atenciones /></LazyPage>} />
        <Route path="/calendario" element={<LazyPage><Calendario /></LazyPage>} />
        <Route path="/tratamientos" element={<LazyPage><Tratamientos /></LazyPage>} />
        <Route path="/gastos" element={<LazyPage><Gastos /></LazyPage>} />
        <Route path="/reportes" element={<LazyPage><Reportes /></LazyPage>} />
        <Route path="/configuracion" element={<LazyPage><Configuracion /></LazyPage>} />
      </Route>

      <Route
        path="/usuarios"
        element={
          <ProtectedAdminRoute>
            <Layout>
              <LazyPage>
                <Usuarios />
              </LazyPage>
            </Layout>
          </ProtectedAdminRoute>
        }
      />

      <Route path="*" element={<Navigate to={homePage} replace />} />
    </Routes>
  )
}
